import cn from "classnames";

import { func } from "../../../../utils";
import { Button, Text } from "../../../atoms";

const Banner = ({
  title = "banner2 Campaign Image",
  data = {},
  className = "",
}) => {
  const classNames = cn("banner2", className);
  const backdrop = ({ numofThunder }) => {
    return (
      <div className="banner2__backdrop">
        <div className="banner2__backdrop--d">
          {Array.from(Array(numofThunder).keys()).map((_, i) => {
            return (
              <img
                key={i}
                src={func.getStaticImg(`illustration/thunder/thunder${i}.svg`)}
                alt={`thunder${i}`}
                className={`thunder${i}`}
              />
            );
          })}
          <img
            src={func.getStaticImg(`illustration/basketball.svg`)}
            alt={`basketball`}
            className={`basketball`}
          />
          <img
            src={func.getStaticImg(`illustration/simcard.svg`)}
            alt={`simcard`}
            className={`simcard`}
          />
          <img
            src={func.getStaticImg(`illustration/soccerball.svg`)}
            alt={`soccerball`}
            className={`soccerball-drop`}
          />
        </div>
        <div className="banner2__backdrop--m">
          <img
            src={func.getStaticImg(`illustration/basketball-mobile.svg`)}
            alt={`basketball`}
            className={`basketball`}
          />
          <img
            src={func.getStaticImg(`illustration/soccerball-mobile.svg`)}
            alt={`soccerball`}
            className={`soccerball-drop1`}
          />
          <img
            src={func.getStaticImg(
              `illustration/thunder/thunder-fragment-mobile.svg`
            )}
            alt={`thunder`}
            className={`thunder--mobile`}
          />
        </div>
      </div>
    );
  };
  return (
    <div className={classNames}>
      {/* -- image */}
      <div className="banner2__img" />
      <div className="banner2__img--m" />
      {backdrop({ numofThunder: 8 })}
      {/* -- package */}
      <div className="banner2__content">
        <div className="banner2__container">
          <div className="banner2__inner">
            <div>
              <img
                src={func.getStaticImg("bg/headline2.png")}
                alt={title}
                className="banner2__img__m"
              />
              <div className="banner2__left">
                <Text className="banner2__subtitle" weight="bold" color="white">
                  Basket - Futsal - Dance
                </Text>
                <div className="banner2__left--d">
                  <Text color="white" weight="bold">
                    Perebutan juara kompetisi Basket, Futsal, dan Dance buat
                    siswa-siswa SMA/SMK Kota Semarang
                  </Text>
                </div>
              </div>
            </div>

            <div className="banner2__pkg">
              <div className="banner2__img__d">
                <img
                  fetchpriority="high"
                  src={func.getStaticImg(`illustration/drop1/byu-logo.png`)}
                  srcset={`${func.getStaticImg(
                    "illustration/drop1/byu-logo.png"
                  )} 1x, ${func.getStaticImg(
                    "illustration/drop1/byu-logo@2x.png"
                  )} 2x, ${func.getStaticImg(
                    "illustration/drop1/byu-logo@3x.png"
                  )} 3x`}
                  alt={"piala-byU"}
                  className="banner2__img__m banner2__img__pialabyU"
                  onClick={() => func.scrollTo("awards-section")}
                />
              </div>
              {/* <img
                fetchpriority="high"
                src={func.getStaticImg("illustration/piala-byU-location.png")}
                alt={"piala-byU"}
                className="banner2__img__m"
              /> */}
              <Text
                size="large"
                weight="bold"
                color="white"
                className="banner2__img__title__location"
              >
                GOR JATIDIRI
              </Text>

              <div className="banner2__img__title__location__container">
                <div className="banner2__img__title__location__container__inner">
                  <Text
                    weight="bold"
                    color="white"
                    className="banner2__img__title__title-date"
                  >
                    Babak Penyisihan
                  </Text>
                  <Text
                    weight="bold"
                    color="white"
                    className="banner2__img__title__date"
                  >
                    22 - 23 Okt
                  </Text>
                </div>
                <div className="vertical-divider2" />
                <div className="banner2__img__title__location__container__inner">
                  <Text
                    weight="bold"
                    color="white"
                    className="banner2__img__title__title-date"
                  >
                    Babak Final
                  </Text>
                  <Text
                    weight="bold"
                    color="white"
                    className="banner2__img__title__date"
                  >
                    5 - 6 Nov
                  </Text>
                </div>
              </div>
              <div className="banner2__img__logo">
                <div className="banner2__img__logo__perbasi">
                  <img
                    fetchpriority="high"
                    src={func.getStaticImg("illustration/perbasi.svg")}
                    alt={"perbasi-logo"}
                    className="banner2__img__m "
                  />
                  <Text
                    weight="bold"
                    color="white"
                    className="banner2__img__title__perbasi"
                  >
                    SEMARANG
                  </Text>
                </div>

                <div>
                  <img
                    fetchpriority="high"
                    src={func.getStaticImg("illustration/futsal.svg")}
                    alt={"futsal-logo"}
                    className="banner2__img__m"
                  />
                </div>
              </div>

              <div className="banner2__left--m">
                <Text color="white" weight="bold">
                  Perebutan juara kompetisi Basket, Futsal, dan Dance buat
                  siswa-siswa SMA/SMK Kota Semarang
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*desktop swoosh */}
      {/* <svg
        className="banner2__wave banner2__wave--d"
        viewBox="0 0 1024 40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1024 0C1005.03 3.40952 984.457 7.15431 962.013 10.495C660.495 55.3756 451.47 7.26761 316.777 1.51273C182.084 -4.24216 88.2622 7.1316 0 23.6367V40H1024V0Z"
          fill="url(#paint0_linear_868_71760)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_868_71760"
            x1="1443"
            y1="50"
            x2="-10"
            y2="49.9999"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#DAE8F0" />
            <stop offset="0.333333" stop-color="white" />
            <stop offset="0.740879" stop-color="#F9FBFD" />
            <stop offset="1" stop-color="#DAE9F1" />
          </linearGradient>
        </defs>
      </svg> */}
      <svg
        className="banner2__wave banner2__wave--d"
        viewBox="0 0 1440 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1443 0C1416.08 8.52381 1386.89 17.8858 1355.04 26.2375C927.206 138.439 630.612 18.169 439.489 3.78182C248.367 -10.6054 115.239 17.829 -9.99998 59.0916V100H1443V0Z"
          fill="url(#paint0_linear_868_71760)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_868_71760"
            x1="1443"
            y1="50"
            x2="-10"
            y2="49.9999"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#DAE8F0" />
            <stop offset="0.333333" stop-color="white" />
            <stop offset="0.740879" stop-color="#F9FBFD" />
            <stop offset="1" stop-color="#DAE9F1" />
          </linearGradient>
        </defs>
      </svg>

      {/*mobile swoosh */}
      <svg
        className="banner2__wave banner2__wave--m"
        viewBox="0 0 375 56"
        fill="#F0F2F9"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.00100708 0V56H375L375 52.0933C359.196 32.3818 324.944 24.6905 272.246 29.0191C264.868 29.6252 257.869 30.3502 251.195 31.1496L248.354 31.4966C247.414 31.6137 246.48 31.7322 245.552 31.852L242.788 32.2148C242.33 32.2759 241.874 32.3372 241.419 32.3988L238.71 32.7715L236.036 33.1498L233.396 33.5329L230.79 33.92C230.358 33.9848 229.928 34.0497 229.499 34.1148L225.674 34.703L223.787 34.9987L218.226 35.8881L214.597 36.4797L202.339 38.4999L198.95 39.0519L195.605 39.5877L192.581 40.0617L190.583 40.368L188.598 40.6658L186.626 40.9546L184.665 41.2337L182.716 41.5025L180.778 41.7605L178.849 42.007L176.929 42.2415L175.018 42.4633C174.382 42.535 173.748 42.6046 173.114 42.6718L171.217 42.8665C147.543 45.2108 125.292 44.1663 97.9797 34.4625C92.8613 32.644 87.8737 30.6881 82.978 28.6636L80.7248 27.7247C79.9759 27.4102 79.2289 27.0944 78.4839 26.7775L76.2543 25.8236L74.0353 24.8644L71.826 23.9016L67.433 21.9707L59.8099 18.6066L56.5607 17.1838L54.3984 16.2454L52.2381 15.3168L50.0791 14.3995L48.9998 13.9455L46.8411 13.048L45.7614 12.6048L43.601 11.7305C29.9126 6.24644 16.0947 1.80549 1.18073 0.126761L0.00100708 0Z"
          fill="#F0F2F9"
        />
      </svg>
    </div>
  );
};

export default Banner;
